export default "__VITE_PUBLIC_ASSET__b15ff481__"